module.exports = __webpack_public_path__ + "img/zuijia_40.7d104b6a.png";